<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="login-box">
          <div class="login-box-content">
            <div class="submit" style="text-align: center; margin-top: 50%">
              {{ tip }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { axiosOptions, axiosRequest } from "../util/request";
import { redirectSSOLogin } from "../util/utils";

export default {
  data() {
    return {
      tip: "登录中，请稍后...",
    };
  },
  created() {
    const ticket = this.$route.query.ticket;
    if (ticket) {
      axiosRequest(
        "/user/sso-login",
        {
          service: `${process.env.VUE_APP_LOGIN_SERVICE_URL}login`,
          ticket: ticket,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            if (res.data.data.redirectUrl) {
              location.href = res.data.data.redirectUrl;
              return;
            }

            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("refreshToken", res.data.data.refreshToken);
            localStorage.setItem("logined", true);
            this.$store.commit("setLogined", true);

            let userInfo = {
              id: res.data.data.id,
              username: res.data.data.username,
              integral: res.data.data.integral,
              freeIntegral: res.data.data.freeIntegral,
              headPhoto: res.data.data.headPhoto,
              vipType: res.data.data.vipType,
              vipTime: res.data.data.vipTime,
              workbenchAccess: res.data.data.workbenchAccess,
              type: res.data.data.type || 0,
            };
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            this.$store.commit("setUserInfo", userInfo);

            if (res.data.data.redirectUrl) {
              location.href = res.data.data.redirectUrl;
            } else if (localStorage.getItem("loginReturnUrl")) {
              const loginReturnUrl = localStorage.getItem("loginReturnUrl");
              localStorage.removeItem("loginReturnUrl");
              this.$router.push(decodeURIComponent(loginReturnUrl));
            } else {
              this.$router.push("/");
            }
          } else {
            this.handleLoginError(res.data.message);
            // redirectSSOLogin();
          }
        })
        .catch(() => {
          this.handleLoginError();
          // redirectSSOLogin();
        });
    } else {
      const returnUrl = this.$route.query.returnUrl;
      if (returnUrl) {
        localStorage.setItem("loginReturnUrl", returnUrl);
      }
      redirectSSOLogin();
    }
  },
  methods: {
    handleLoginError(message) {
      if (message) {
        this.tip = message;
      } else {
        this.tip = "登录异常，请稍后重试";
      }
      this.$message({
        message: this.tip,
        type: "error",
        onClose: () => {
          this.$router.push("/");
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
#header {
  position: static;
  height: 75px;
  background-color: #fff;
  border: 0;
  transform: translateX(0);
  .logo {
    height: 100%;
  }
}
#body {
  height: calc(100vh - 135px);
  min-height: 600px;
  background-size: cover;
  > .wrapper {
    height: 100%;
    min-height: auto;
    margin-top: 0;
  }
}
.login-box {
  position: absolute;
  left: 50%;
  top: 10%;
  width: 440px;
  height: 560px;
  margin-left: -220px;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  box-shadow: 0 0 27px rgba(0, 0, 0, 0.14);
  top: 15%;
  height: 460px;
  @media (max-width: 1400px) {
    top: 3%;
  }
  ::v-deep {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__nav-wrap {
      height: 70px;
      text-align: center;
      border-bottom: 1px solid #ccc;
      &:after {
        display: none;
      }
    }
    .el-tabs__nav {
      display: inline-block;
      float: none;
      vertical-align: top;
    }
    .el-tabs__item {
      display: inline-block;
      height: 69px;
      padding: 0 50px;
      font-size: 20px;
      font-weight: normal;
      line-height: 67px;
    }
    .el-tabs__active-bar {
      height: 3px;
    }
    .el-tabs__content {
      padding: 20px 40px;
    }
  }
  .login-box-title {
    height: 70px;
    text-align: center;
    border-bottom: 1px solid #ccc;
    h2 {
      display: inline-block;
      font-size: 20px;
      font-weight: normal;
      line-height: 67px;
      border-bottom: 3px solid #0068d6;
    }
  }
  .login-box-content {
    padding: 20px 40px;
  }
  ::v-deep {
    .el-input__inner {
      height: 52px;
      border-radius: 5px;
    }
    .el-input-group__append {
      padding: 0 0 0 18px;
      border: 0;
      background-color: transparent;
      img,
      .el-button {
        width: 142px;
        height: 50px;
        margin: 0;
        border: 1px solid #ccc;
        vertical-align: top;
      }
    }
  }
  .el-form-item {
    &:last-child {
      margin-bottom: 0;
    }
  }
  .text {
    margin: -10px 0 0;
    .el-col + .el-col {
      text-align: right;
    }
  }

  .submit {
    .el-button {
      width: 100%;
      padding: 18px 20px;
      font-size: $fontSizeBig;
      border-radius: 5px;
      + .el-button {
        margin: 13px 0 0;
      }
    }
  }
  .ip {
    line-height: 50px;
    text-align: center;
    border-bottom: 1px solid #cccccc;
  }
  .tip {
    padding-top: 15px;
    line-height: 24px;
  }
}
@media screen and (max-width: 768px) {
  #body {
    min-height: inherit;
    height: calc(100vh - 150px);
  }
  .login-box {
    top: 50%;
    max-width: calc(100vw - 40px);
    height: 320px;
    margin-top: -155px;
    margin-left: calc(-50vw + 20px);
    .login-box-title {
      height: 44px;
      h2 {
        font-size: 16px;
        line-height: 41px;
      }
    }
    .login-box-content {
      padding: 10px 15px;
    }
    .el-form-item {
      margin-bottom: 15px;
    }
    .text {
      margin: -15px 0 0;
    }
    .submit {
      .el-button {
        padding: 10px 20px;
        font-size: 14px;
      }
    }
    ::v-deep {
      .el-input__inner {
        height: 36px;
      }
      .el-input-group__append {
        //img,
        .el-button {
          width: calc(100vw / 2 - 60px);
          height: 36px;
          margin: 0;
          padding: 8px 10px;
          border: 1px solid #ccc;
          vertical-align: top;
        }
        img {
          width: calc(100vw / 2 - 60px);
          height: 36px;
          margin: 0;
          border: 1px solid #ccc;
          vertical-align: top;
        }
      }
      .el-tabs__nav-wrap {
        height: 50px;
      }
      .el-tabs__item {
        height: 49px;
        line-height: 47px;
        padding: 0 30px;
        font-size: 16px;
      }
      .el-tabs__content {
        padding: 20px;
      }
    }
  }
}
</style>
